<style>
  .container-gauge{
    height: 350px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/co/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
      <vs-tabs>
        <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
          <div>{{$t('Labels.Today')}} <span v-if="!showAvg24">: {{$t('Labels.NoData')}} </span></div>
          <div class="flex flex-wrap" v-if="showAvg24">
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-4">
              <statistics
                img="co2_blue"
                :value="parseFloat(avg24.avg_ppm).toFixed(2)"
                :min="parseFloat(avg24.min_ppm).toFixed(2)"
                :max="parseFloat(avg24.max_ppm).toFixed(2)"
                unit="ppm"
                :title="$t('Labels.Co2')"
              />
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-4">
              <statistics
                img="temperature"
                :value="parseFloat(avg24.avg_tem).toFixed(2)"
                :min="parseFloat(avg24.min_temp).toFixed(2)"
                :max="parseFloat(avg24.max_temp).toFixed(2)"
                unit="°C"
                :title="$t('Labels.Temperature')"
              />
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-4">
              <statistics
                img="humedad"
                :value="parseFloat(avg24.avg_hum).toFixed(2)"
                :min="parseFloat(avg24.min_hum).toFixed(2)"
                :max="parseFloat(avg24.max_hum).toFixed(2)"
                unit="%"
                :title="$t('Labels.Humidity')"
              />
            </div>
          </div>
          <div>{{$t('Labels.Last24Hours')}} <span v-if="!showToday">: {{$t('Labels.NoData')}} </span></div>
          <div class="flex flex-wrap" v-if="showToday">
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card  :title="$tc('Labels.StatisticCO2',1)">
                <apexchart v-if="ppmToday.loaded" type="line" height="350" :options="ppmToday.options" :series="ppmToday.data"></apexchart>
              </vx-card>
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card  :title="$tc('Labels.StatisticHumidity',1)">
                <apexchart v-if="humdityToday.loaded" type="line" height="350" :options="humdityToday.options" :series="humdityToday.data"></apexchart>
              </vx-card>
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card   :title="$tc('Labels.StatisticTemperature',1)">
                <apexchart v-if="tempToday.loaded" type="line" height="350" :options="tempToday.options" :series="tempToday.data"></apexchart>
              </vx-card>
            </div>
          </div>
          <div>{{$t('Labels.LastWeek')}} <span v-if="!showWeek">: {{$t('Labels.NoData')}} </span></div>
          <div class="flex flex-wrap" v-if="showWeek">
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card :title="$tc('Labels.StatisticCO2',2)">
                <apexchart v-if="ppmWeek.loaded" type="line" height="350" :options="ppmWeek.options" :series="ppmWeek.data"></apexchart>
              </vx-card>
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card :title="$tc('Labels.StatisticHumidity',2)">
                <apexchart v-if="humdityWeek.loaded" type="line" height="350" :options="humdityWeek.options" :series="humdityWeek.data"></apexchart>
              </vx-card>
            </div>
            <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3 p-3">
              <vx-card   :title="$tc('Labels.StatisticTemperature',2)">
                <apexchart v-if="tempWeek.loaded" type="line" height="350" :options="tempWeek.options" :series="tempWeek.data"></apexchart>
              </vx-card>
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
          <vx-card
              title="Últimas Lecturas">
                  <div style="width: 100%">
                    <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                <div class="vx-row mb-5">
                  <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
                    <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
                  </div>
                  <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
                    <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
                      <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
                    </vs-button>
                    <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
                      <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
                    </vs-button>
                  </div>
                  <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
                    <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                  </div>
                </div>
                <vs-table v-if="response" ref="table" :data="response">
                <template slot-scope="{data}">
                  <tbody>
                    <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                      <listItem
                        :value="item.created_at"
                        :description="$t('Labels.Date')"
                        img="fecha"
                      ></listItem>
                      <listItem
                        :value="item.created_at"
                        :description="$t('Labels.LastUpdated')"
                        img="clock"
                        :relativeTime="true"
                      ></listItem>
                      <listItem
                        :value="parseFloat(item.ppm_current).toFixed(2)"
                        :description="$t('Labels.Co2')"
                        img="co2"
                        unit="ppm"
                      ></listItem>
                      <listItem
                        :value="parseFloat(item.temp_current).toFixed(2)"
                        :description="$t('Labels.Temperature')"
                        img="temperature"
                        unit="°C"
                      ></listItem>
                      <listItem
                        :value="parseFloat(item.hum_current).toFixed(2)"
                        :description="$t('Labels.Humidity')"
                        img="humedad"
                        unit="%"
                      ></listItem>
                    </tr>
                  </tbody>
                </template>
              </vs-table>
            <vs-pagination v-if="response.length > 0" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
          </vx-card>
        </vs-tab>
        <!-- <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
          <div class="absolute right-0">
            <label for="" class="inline-block align-middle">{{$t('Labels.Refresh')}}</label>
            <vs-switch v-model="activeRefresh" class="inline-block align-middle ml-2" />
          </div>
          <div class="flex mt-12" v-if="showGauges">
            <div class="flex-1 p-4">
              <vx-card class="container-gauge">
                <gaugeCo2
                  :min="0"
                  :max="3000"
                  :alertMin="600"
                  :warning="1000"
                  :alertMax="3000"
                  :title="$t('Labels.MeterVirus')"
                  :value="parseFloat(gauges.ppm_current) || 0"
                  unit="ppm"
                />
              </vx-card>
            </div>
            <div class="flex-1 p-4">
              <vx-card class="container-gauge">
                <gaugeCo2
                  :min="parseInt(limits.co2.min)"
                  :max="parseInt(limits.co2.max)"
                  :alertMin="1000"
                  :warning="1600"
                  :alertMax="3000"
                  :title="$t('Labels.airQuality')"
                  :value="parseFloat(gauges.ppm_current) || 0"
                  unit="ppm"
                />
              </vx-card>
            </div>
            <div class="flex-1 p-4">
              <vx-card class="container-gauge">
                <gauge
                  :min="limits.temperature.min"
                  :max="limits.temperature.max"
                  :alertMin="gauges.temp_min"
                  :alertMax="gauges.temp_max"
                  :title="$t('Labels.Temperature')"
                  :value="gauges.temp_current || 0"
                  unit="°C"
                />
              </vx-card>
            </div>
            <div class="flex-1 p-4">
              <vx-card class="container-gauge">
                <gauge
                  :min="limits.humidity.min"
                  :max="limits.humidity.max"
                  :alertMin="gauges.hum_min"
                  :alertMax="gauges.hum_max"
                  :title="$t('Labels.Humidity')"
                  :value="gauges.hum_current || 0"
                  unit="%"
                />
              </vx-card>
            </div>
          </div>
        </vs-tab> -->
      </vs-tabs>
    </div>
  </div>

</div>

</template>

<script>
import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
// import gauge from '@/components/gauge/gauge.vue'
// import gaugeCo2 from '@/components/gauge/gaugeCo2.vue'
import { empty } from '@/helpers.js'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'

export default {
  components: {
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    'v-select': vSelect,
    apexchart,
    listItem,
    statistics
    // gauge,
    // gaugeCo2
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      filters: {
        offset: 0,
        byColumn: 'created_at',
        byOrder: 'DESC'
      },
      columnOrders: [
        { label: this.$t('Labels.Co2'), value: 'ppm_current' },
        { label: this.$t('Labels.Temperature'), value: 'temp_current' },
        { label: this.$t('Labels.Humidity'), value: 'hum_current' },
        { label: this.$t('Labels.Date'), value: 'created_at' }
      ],
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      humidity: {
        data: [{ data: [], name: this.$t('Labels.Humidity') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [this.$t('Labels.Min'), this.$t('Labels.Avg'), this.$t('Labels.Max')]
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} %`
              }
            }
          }
        }
      },
      temp: {
        data: [{ data: [], name: this.$t('Labels.Temperature') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [this.$t('Labels.Min'), this.$t('Labels.Avg'), this.$t('Labels.Max')]
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} °C`
              }
            }
          }
        }
      },
      ppm: {
        data: [{ data: [], name: 'CO2' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [this.$t('Labels.Min'), this.$t('Labels.Avg'), this.$t('Labels.Max')]
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ppm`
              }
            }
          }
        }
      },
      humdityWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      ppmWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      humdityToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      ppmToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      log_limit: '5',
      uuid: this.$route.params.uuid,
      urlDownload: '',
      avg24: {},
      gauges: [],
      limits: [],
      showGauges: false,
      showAvg24: false,
      showWeek: false,
      showToday: false,
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    async getResponse () {
      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.filters.limit = this.log_limit

      this.$vs.loading()
      const params = {
        url: `co2_devices/${this.uuid}/log`,
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },

    async getDayStatictics () {
      this.$vs.loading()
      const params = {
        url: `co2_devices/${this.uuid}/stadistics`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (!empty(this.avg24)) {
          this.humidity.data[0].data.push(parseFloat(this.avg24.min_hum).toFixed(2))
          this.humidity.data[0].data.push(parseFloat(this.avg24.avg_hum).toFixed(2))
          this.humidity.data[0].data.push(parseFloat(this.avg24.max_hum).toFixed(2))

          this.temp.data[0].data.push(parseFloat(this.avg24.min_temp).toFixed(2))
          this.temp.data[0].data.push(parseFloat(this.avg24.avg_tem).toFixed(2))
          this.temp.data[0].data.push(parseFloat(this.avg24.max_temp).toFixed(2))

          this.temp.data[0].data.push(parseFloat(this.avg24.min_ppm).toFixed(2))
          this.temp.data[0].data.push(parseFloat(this.avg24.avg_ppm).toFixed(2))
          this.temp.data[0].data.push(parseFloat(this.avg24.max_ppm).toFixed(2))
          this.humidity.loaded = true
          this.temp.loaded = true
          this.showAvg24 = true
        }
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `co2_devices/${this.uuid}/week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this

        this.humdityWeek.labels = []
        this.humdityWeek.dataAvg = []
        this.humdityWeek.dataMin = []
        this.humdityWeek.dataMax = []

        this.tempWeek.labels = []
        this.tempWeek.dataAvg = []
        this.tempWeek.dataMin = []
        this.tempWeek.dataMax = []

        this.ppmWeek.labels = []
        this.ppmWeek.dataAvg = []
        this.ppmWeek.dataMin = []
        this.ppmWeek.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempWeek.labels.push(item.day.split(' ')[0])
          api.tempWeek.dataAvg.push(parseFloat(item.avg_tem).toFixed(2))
          api.tempWeek.dataMin.push(parseFloat(item.min_temp).toFixed(2))
          api.tempWeek.dataMax.push(parseFloat(item.max_temp).toFixed(2))
          api.humdityWeek.labels.push(item.day.split(' ')[0])
          api.humdityWeek.dataAvg.push(parseFloat(item.avg_hum).toFixed(2))
          api.humdityWeek.dataMin.push(parseFloat(item.min_hum).toFixed(2))
          api.humdityWeek.dataMax.push(parseFloat(item.max_hum).toFixed(2))
          api.ppmWeek.labels.push(item.day.split(' ')[0])
          api.ppmWeek.dataAvg.push(parseFloat(item.avg_ppm).toFixed(2))
          api.ppmWeek.dataMin.push(parseFloat(item.min_ppm).toFixed(2))
          api.ppmWeek.dataMax.push(parseFloat(item.max_ppm).toFixed(2))
        })

        this.humdityWeek.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.humdityWeek.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.humdityWeek.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.humdityWeek.dataMax
          }
        ]
        this.tempWeek.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.tempWeek.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.tempWeek.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.tempWeek.dataMax
          }
        ]
        this.ppmWeek.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.ppmWeek.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.ppmWeek.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.ppmWeek.dataMax
          }
        ]
        this.humdityWeek.options = this.getOptions()
        this.humdityWeek.options.xaxis.categories = this.humdityWeek.labels
        this.humdityWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}%`
            }
          }
        }
        this.tempWeek.options = this.getOptions()
        this.tempWeek.options.xaxis.categories = this.tempWeek.labels
        this.tempWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}°C`
            }
          }
        }
        this.ppmWeek.options = this.getOptions()
        this.ppmWeek.options.xaxis.categories = this.ppmWeek.labels
        this.ppmWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}ppm`
            }
          }
        }

        if (!empty(response.data.data[0])) {
          this.tempWeek.loaded = true
          this.humdityWeek.loaded = true
          this.ppmWeek.loaded = true
          this.$vs.loading.close()
          this.showWeek = true
        }
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getOptions () {
      return {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}`
            }
          }
        }
      }
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `co2_devices/${this.uuid}/today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.humdityToday.labels = []
        this.humdityToday.dataAvg = []
        this.humdityToday.dataMin = []
        this.humdityToday.dataMax = []

        this.tempToday.labels = []
        this.tempToday.dataAvg = []
        this.tempToday.dataMin = []
        this.tempToday.dataMax = []

        this.ppmToday.labels = []
        this.ppmToday.dataAvg = []
        this.ppmToday.dataMin = []
        this.ppmToday.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.tempToday.dataAvg.push(parseFloat(item.avg_tem).toFixed(2))
          api.tempToday.dataMin.push(parseFloat(item.min_temp).toFixed(2))
          api.tempToday.dataMax.push(parseFloat(item.max_temp).toFixed(2))
          api.humdityToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.humdityToday.dataAvg.push(parseFloat(item.avg_hum).toFixed(2))
          api.humdityToday.dataMin.push(parseFloat(item.min_hum).toFixed(2))
          api.humdityToday.dataMax.push(parseFloat(item.max_hum).toFixed(2))
          api.ppmToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.ppmToday.dataAvg.push(parseFloat(item.avg_ppm).toFixed(2))
          api.ppmToday.dataMin.push(parseFloat(item.min_ppm).toFixed(2))
          api.ppmToday.dataMax.push(parseFloat(item.max_ppm).toFixed(2))
        })

        this.humdityToday.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.humdityToday.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.humdityToday.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.humdityToday.dataMax
          }
        ]
        this.tempToday.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.tempToday.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.tempToday.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.tempToday.dataMax
          }
        ]
        this.ppmToday.data = [
          {
            name: this.$t('Labels.Minimum'),
            data: this.ppmToday.dataMin
          },
          {
            name: this.$t('Labels.Average'),
            data: this.ppmToday.dataAvg
          },
          {
            name: this.$t('Labels.Maximum'),
            data: this.ppmToday.dataMax
          }
        ]
        this.humdityToday.options = this.getOptions()
        this.humdityToday.options.xaxis.categories = this.humdityToday.labels
        this.humdityToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}%`
            }
          }
        }

        this.tempToday.options = this.getOptions()
        this.tempToday.options.xaxis.categories = this.tempToday.labels
        this.tempToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}°C`
            }
          }
        }

        this.ppmToday.options = this.getOptions()
        this.ppmToday.options.xaxis.categories = this.ppmToday.labels
        this.ppmToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}ppm`
            }
          }
        }
        if (!empty(response.data.data[0])) {
          this.tempToday.loaded = true
          this.humdityToday.loaded = true
          this.ppmToday.loaded = true
          this.$vs.loading.close()
          this.showToday = true
        }
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.Co2'))
      headers.push(this.$t('Labels.Temperature'))
      headers.push(this.$t('Labels.Humidity'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        row.push(`${item.ppm_current}ppm`)
        row.push(`${item.temp_current}°C`)
        row.push(`${item.hum_current}%`)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      /* this.gauges = DATADETAIL.data
      this.limits = {
          ppm: {
            min: 400,
            max: 2000
          },
          temperature: {
            min: 15,
            max: 100
          },
          humidity: {
            min: 0,
            max: 100
          }
        }
      this.showGauges = true */
      this.$vs.loading()
      const params = {
        url: `co2_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getCharts()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    },
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
